<template>
  <generic-modal :title="$t('destinatary')" ref="generic_modal">
    <form>
      <div class="field">
        <generic-dropdown
          :title="$t('destinatary type')"
          :placeholder="$t('select one')"
          :is_multiple="false"
          url="/account-request/destinatary-type/catalog"
          name_field="name"
          value_field="destinatary_type_id"
          @selected="destinatary_type_changed"
          ref="destinatary_type_dropdown"
        />
      </div>
      <!-- DPI del Cliente -->
      <div class="field">
        <label class="label">{{ $t("dpi") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.dpi"
            :placeholder="$t('dpi')"
            maxlength="20"
            required
          />
        </div>
      </div>

      <!-- Email del Cliente -->
      <div class="field">
        <label class="label">{{ $t("email") }}</label>
        <div class="control">
          <input
            class="input"
            type="email"
            v-model="meta.email"
            :placeholder="$t('email')"
            required
          />
        </div>
      </div>

      <!-- Teléfono del Cliente -->
      <div class="field">
        <label class="label">{{ $t("phone") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.phone"
            :placeholder="$t('phone')"
            maxlength="20"
          />
        </div>
      </div>
    </form>

    <!-- Mensajes de error -->
    <div class="notification is-danger" v-if="error" v-html="error"></div>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import {
  post,
  put,
  get,
  success_message,
  error_message,
  generate_error_message_text,
} from "@/utils";

export default {
  name: "DestinataryModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {
        dpi: "",
        email: "",
        phone: "",
        settings: {},
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return (
        !this.meta.dpi.trim() ||
        !this.meta.email.trim() ||
        !this.is_valid_email(this.meta.email)
      );
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.meta.uuid = uuid;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_entity(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {
        dpi: "",
        email: "",
        phone: "",
        settings: {},
      };
      this.error = "";
      this.$refs.destinatary_type_dropdown.clear();
    },
    get_entity(uuid) {
      let v = this;
      get("/account-request/destinatary", { uuid: uuid })
        .then((response) => {
          v.meta = response;

          if (response.destinatary_type_id) {
            v.$refs.destinatary_type_dropdown.set_value(
              response.destinatary_type_id
            );
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (v.is_form_invalid) {
        v.error = "Por favor complete los campos requeridos";
        return;
      }

      v.error = "";
      let data = { ...v.meta };

      if (v.meta.uuid) {
        post("/account-request/destinatary", data)
          .then(() => {
            success_message(v.$t("destinatary updated successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/account-request/destinatary", data)
          .then(() => {
            success_message(v.$t("destinatary created successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    is_valid_email(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    destinatary_type_changed(type) {
      if (type) {
        this.meta.destinatary_type_id = type.destinatary_type_id;
      }
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 600px;
  max-width: 90vw;
}
</style>
